// extracted by mini-css-extract-plugin
module.exports = {"resendBlock":"f8iWu","sentMessage":"DvTl-"};